<template>
  <backend>
    <v-card :loading="loading">
      <v-card-title>
        Cambiar Orden
        <v-spacer/>
        <v-btn small color="primary" class="mx-1" :outlined="selected !== 'categories'" @click="changeMode('categories')">
          Categorías
        </v-btn>
        <v-btn small color="primary" class="mx-1" :outlined="selected !== 'posts'" @click="changeMode('posts')">
          Posts
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>

        <v-data-table :headers="categoryHeaders" :items="getSortedCategories" :items-per-page="10" v-show="isHiddenTable('categories')">
          <template v-slot:item.action="{ item }">
            <v-btn icon @click="moveCategory('up', item.id)">
              <v-icon>mdi-arrow-up-bold</v-icon>
            </v-btn>
            <v-btn icon @click="moveCategory('down', item.id)">
              <v-icon>mdi-arrow-down-bold</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <v-data-table :headers="postHeaders" :items="getSortedPosts" :items-per-page="10" v-show="isHiddenTable('posts')">
          <template v-slot:item.action="{ item }">
            <v-btn icon @click="movePost('up', item.id)">
              <v-icon>mdi-arrow-up-bold</v-icon>
            </v-btn>
            <v-btn icon @click="movePost('down', item.id)">
              <v-icon>mdi-arrow-down-bold</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.category="{ item }">
            {{ item.category.name }}
          </template>
        </v-data-table>

      </v-card-text>
    </v-card>
  </backend>
</template>

<script>
  import Backend from '../../layouts/Backend';
  import _ from 'lodash';
  import axios from 'axios';
  import {apiRoute} from '../../config';

  export default {
    components: {Backend},
    name: 'ChangeOrder',
    data() {
      return {
        selected: 'categories',
        loading: false,
        categoryHeaders: [
          {text: 'Nombre', sortable: false, value: 'name'},
          {text: 'General', sortable: false, value: 'general', width: '70px', align: 'center'},
          {text: 'Orden', sortable: false, value: 'order', width: '70px', align: 'center'},
          {text: 'Acciones', sortable: false, value: 'action', width: '70px', align: 'center'},
        ],
        postHeaders: [
          {text: 'Nombre', sortable: false, value: 'title'},
          {text: 'Categoría', sortable: false, value: 'category'},
          {text: 'Orden', sortable: false, value: 'order', width: '70px', align: 'center'},
          {text: 'Acciones', sortable: false, value: 'action', width: '70px', align: 'center'},
        ],
        categories: [],
        posts: [],
      };
    },
    computed: {
      getSortedCategories() {
        return _.sortBy(this.categories, 'order');
      },
      getSortedPosts() {
        return _.sortBy(this.posts, 'order');
      },
    },
    async beforeMount() {
      await this.getCategories();
      await this.getPosts();
    },
    methods: {
      isHiddenTable(type) {
        return this.selected === type;
      },
      changeMode(selection) {
        this.selected = selection;
      },
      moveCategory(direction, id) {
        let order = this.categories.find(i => i.id === id).order;
        let newOrder;

        if (direction === 'up') {
          newOrder = order - 1;
        } else if (direction === 'down') {
          newOrder = order + 1;
        }

        if (newOrder < 1 || newOrder > this.categories.length) {
          return false;
        }

        let toSwithOrder = this.categories.find(i => i.order === newOrder).id;

        if (toSwithOrder) {
          this.categories.find(i => i.id === toSwithOrder).order = order;
        }

        this.categories.find(i => i.id === id).order = newOrder;

        this.changeCategoryOrder(id, newOrder);
        this.changeCategoryOrder(toSwithOrder, order);
      },
      movePost(direction, id) {
        let order = this.posts.find(i => i.id === id).order;
        let newOrder;

        if (direction === 'up') {
          newOrder = order - 1;
        } else if (direction === 'down') {
          newOrder = order + 1;
        }

        if (newOrder < 1 || newOrder > this.posts.length) {
          return false;
        }

        let toSwithOrder = this.posts.find(i => i.order === newOrder).id;

        if (toSwithOrder) {
          this.posts.find(i => i.id === toSwithOrder).order = order;
        }

        this.posts.find(i => i.id === id).order = newOrder;

        this.changePostOrder(id, newOrder);
        this.changePostOrder(toSwithOrder, order);
      },
      async getCategories() {
        this.categories = (await axios.get(apiRoute('categories'))).data;
      },
      async getPosts() {
        try {
          this.loading = !this.loading;
          let headers = this.$store.getters.authHeader;
          let response = await axios.get(apiRoute(`search/all?page=1&itemsPerPage=-1`), headers);

          this.posts = response.data.posts;
        } catch (ex) {
          throw ex;
        } finally {
          this.loading = !this.loading;
        }
      },
      async changeCategoryOrder(id, newOrder) {
        let headers = this.$store.getters.authHeader;
        await axios.put(apiRoute(`categories/${id}`), {order: newOrder}, headers);
      },
      async changePostOrder(id, newOrder) {
        let headers = this.$store.getters.authHeader;
        await axios.put(apiRoute(`post/${id}`), {order: newOrder}, headers);
      },
    },
  };
</script>